import React from "react";
import SimpleReactValidator from 'simple-react-validator';
import Loader from "../../../common/Misc/Loader";
import { addTranscation, allTenantByUserId } from "../../../Services/Transaction" ;
import { getAllProperty } from '../../../Services/Property';
import { getErrorMessage } from "../../../helpers/Utils";
import showNotification from "../../../helpers/Notify";
import { Link } from 'react-router-dom';
import {withRouter } from "../../../helpers/withRouter"

class AddTransaction extends React.Component{
    constructor(props){
    super(props);
    this.state = {
        property: '',
        unit:'',
        transaction_date: new Date(),
        account : '',
        category: '',
        bank_account: '',
        amount : '',
        status: '',
        description_title: '',
        description: '',
        payment_mode :'',
        receipt_image : '',
        allPropertyList : [],  
        tenantByUserID : [],
        image_list :[],
        file_name : '',
        allUnits:[]
    };

        this.validator = new SimpleReactValidator();
        this.submitForm =async()=> {
            if (this.validator.allValid()) { 
            this.setState({requestInprogress : true});
            let allFileIds = [];
            this.state.image_list.map((row) => {
                allFileIds.push(row.id);
                return false;
            });
            let request = {
                ...this.state,
                file_ids:allFileIds,
            };
            let response = await addTranscation(request);
            this.setState({requestInprogress : false});
                if(response.data.success){
                    showNotification(getErrorMessage(response.data.message), 'success');
                    this.redirectUser();
                } else {
                    showNotification(getErrorMessage(response.data.message), 'warning');
                }
            } else {
            this.validator.showMessages();
            this.forceUpdate();
            }    
        } 
    }

    redirectUser()
    {
        this.props.navigate('/transaction')
    }

    
    setValue = (e, field)=>{
        this.setState({...this.state, [field]:e.target.value});
        if(field === 'property'){
            this.setUnit(e.target.value);
        }
     } 
     setUnit = (selected_id) => {
        console.log(selected_id, 'vselected_id');
        let allProperty = this.state.allPropertyList;
        allProperty.map((row) => {
            if(row.id == selected_id){

                console.log(row.property_types, 'property_types');
                this.setState({
                    allUnits : row.property_types
                });
            }
        });

    }

     componentDidMount = async() => {
        let allPropertyList = await getAllProperty();
        this.setState({allPropertyList : allPropertyList.data.data });

        let tenantByUserID = await allTenantByUserId();
        this.setState({tenantByUserID : tenantByUserID.data.data });
        console.log(allPropertyList, tenantByUserID , 'Response')
    }
    
    uploadReceipt = (e) => {
        let file = e.target.files;
        var reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
            this.setState({
                profile_pic_path : reader.result,
                file_name : file[0].name
            });
        };
    }
           
    render(){
        return(
            <>  
                <div className="content-wrapper">
                    <div className="page-header">
                        <div className="left-cell">
                            <h3 className="page-title">Add transaction</h3>
                        </div>
                    </div>
                    <div className="detail-cont">
                        <div className="row">
                            <div className="col-md-12 grid-margin stretch-card flex-column">
                            <div className="card mb-4">
                                <div className="card-body pt-0">
                                    <div className="forms-sample">
                                        <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="exampleInputPriority">Property </label>
                                                <select className="form-control tex-select select_btn" name = "property" id="property" value={this.state.property} onChange={(e)=>this.setValue(e,'property')}>
                                                    <option className="unselect">Select Property</option>
                                                    {
                                                        this.state.allPropertyList.map((row) => (
                                                            <option value={row.id} key={row.id}>{row.property_name+' ('+row.street_address + ', ' +row.city+')'}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                            {this.validator.message('property', this.state.property, 'required')}
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="exampleInputPriority">Select Property Unit </label>
                                                <select className="form-control tex-select select_btn" name = "unit" id="unit" value={this.state.unit} onChange={(e)=>this.setValue(e,'unit')}>
                                                    <option className="unselect">Select Unit</option>
                                                    {
                                                        this.state?.allUnits?.length > 0 ? (
                                                            this.state.allUnits.map((row) => (
                                                                <option value={row.id} key={row.id}>{row.unit+' ('+ row.unit_type +')'}</option>
                                                            ))
                                                        ) : ""
                                                    }
                                                </select>
                                            </div>
                                            {this.validator.message('unit', this.state.property, 'unit')}
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="exampleInputPriority">Transaction Date </label>
                                                <div className="input-group input-group-icon mb-3">
                                                    <input type="date" name = "transaction_date" id = "transaction_date" className="form-control" aria-label="Recipient's username" aria-describedby="basic-addon2" value={this.state.transaction_date} onChange={(e)=>this.setValue(e,'transaction_date')}/>
                                                    <div className="input-group-append p-0">
                                                    <span className="input-group-text" id="basic-addon2"><i className="mdi mdi-calendar"></i></span>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.validator.message('transaction_date', this.state.transaction_date, 'required')}
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="exampleInputPriority">Transaction Type</label>
                                                <select className="form-control tex-select select_btn" name = "transaction_type" id="transaction_type" value={this.state.transaction_type} onChange={(e)=>this.setValue(e,'transaction_type')}>
                                                    <option className="unselect">Select Transaction Type</option>
                                                    <option value ="money_in">Money In</option>
                                                    <option value ="money_out">Money Out</option>
                                                </select>
                                            </div>
                                            {this.validator.message('transaction_type', this.state.transaction_type, 'required')}
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="exampleInputPriority">Paid By</label>
                                                <select className="form-control tex-select select_btn" name = "paid_by" id="paid_by" value={this.state.paid_by} onChange={(e)=>this.setValue(e,'paid_by')}>
                                                    <option className="unselect">Select</option>
                                                    {
                                                        this.state.tenantByUserID.map((row) => (
                                                            <option value={row.id} key={row.id}>{row.first_name+ ' ' +row.last_name}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                            {this.validator.message('paid_by', this.state.paid_by, 'required')}
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="exampleInputPriority">Category </label>
                                                <select className="form-control tex-select select_btn" name = "category" id="category" value={this.state.category} onChange={(e)=>this.setValue(e,'category')}>
                                                    <option className="unselect">Select Category</option>
                                                    <option value="utilities" key="1">Utilities</option>
                                                    <option value="rent" key="2">Rent</option>
                                                    <option value="monthly-service" key="3">Monthly Service</option>
                                                </select>
                                            </div>
                                            {this.validator.message('category', this.state.category, 'required')}
                                        </div>
                                        {/* <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="exampleInputPriority">Select Card:  </label>
                                                <select className="form-control tex-select select_btn" name = "bank_account" id="bank_account" value={this.state.bank_account} onChange={(e)=>this.setValue(e,'bank_account')}>
                                                    <option className="unselect">Select Bank Account</option>
                                                    <option>Chase - BUS COMPLETE CHK</option>
                                                    <option>No Bank</option>
                                                </select>
                                            </div>
                                            {this.validator.message('bank_account', this.state.bank_account, 'required')}
                                        </div> */}
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="exampleInputEnterDT">Item Amount </label>
                                                <input type="number" className="form-control" name= "amount" id="amount" placeholder="$0.00" value={this.state.amount} onChange={(e)=>this.setValue(e,'amount')}/>
                                            </div>
                                            {this.validator.message('amount', this.state.amount, 'required')}
                                        </div>

                                        {/* 'pending','in_transition','done','void','cancel','failed','requested','in_progress','deleted','refund','partial_refund' */}

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="exampleInputPriority">Payment Mode</label>
                                                <select className="form-control tex-select select_btn" name= "payment_mode" id="payment_mode" value={this.state.payment_mode} onChange={(e)=>this.setValue(e,'payment_mode')}>
                                                    <option className="unselect">Select Payment Mode</option>
                                                    <option value ="cash">Cash</option>
                                                    <option value ="credit_debit_card">Credit/Debit Card</option>
                                                    <option value ="cheque">Cheque</option>
                                                    <option value ="bank_transfer">Bank Transfer</option>
                                                    <option value ="other">Other</option>
                                                </select>
                                            </div>
                                            {this.validator.message('payment_mode', this.state.payment_mode, 'required')}
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="exampleInputPriority">Status</label>
                                                <select className="form-control tex-select select_btn" name= "status" id="status" value={this.state.status} onChange={(e)=>this.setValue(e,'status')}>
                                                    <option className="unselect">Select Status</option>
                                                    {/* <option value ="pending">Pending</option> */}
                                                    {/* <option value ="in_transaction">In Transition</option> */}
                                                    <option value ="done">Paid</option>
                                                    {/* <option value ="void">Void</option> */}
                                                    {/* <option value ="cancel">Cancel</option> */}
                                                    <option value ="requested">Requested</option>
                                                    {/* <option value ="refund">Refund</option> */}
                                                </select>
                                            </div>
                                            {this.validator.message('status', this.state.status, 'required')}
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="exampleInputEnterDT">Description Title </label>
                                                <input type="text" className="form-control" name = "description_title" id="exampleInputEnterDT" placeholder="" value={this.state.description_title} onChange={(e)=>this.setValue(e,'description_title')}/>
                                            </div>
                                            {this.validator.message('description_title', this.state.description_title, 'required')}
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label for="exampleInputEnterDT">Description </label> 
                                                <textarea className="form-control" name = "description" rows="7" value={this.state.description} onChange={(e)=>this.setValue(e,'description')}></textarea>
                                            </div>
                                            {this.validator.message('description', this.state.description, 'required')}
                                        </div>
                                        
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Receipt Image : </label>    
                                                <div className="drop_box mar_drop_box ">
                                                    <div className="upload-btn-wrapper">
                                                    <button className="btn bg-orange btn-cus text-white">
                                                        <i className="mdi mdi-cloud-upload text-muted"></i>
                                                        <p>Upload Receipt Image </p>
                                                    </button>
                                                    <input type="file" name="receipt_image" accept="image/*" onClick={(e)=>{this.uploadReceipt(e)}} />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* {this.validator.message('receipt_image', this.state.receipt_image, 'required')} */}
                                        </div>

                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card  mb-4">
                                <div className="card-body p-0">
                                    <div className="d-flex justify-content-between">
                                        <Link to = "/transaction" type="button" className="btn btn-outline-dark">Cancal</Link>
                                        <button className="btn bg-orange btn-cus mr-2 text-white" disabled={ this.state.requestInprogress}  onClick={this.submitForm}>
                                        { this.state.requestInprogress ? (<Loader className="btn theme-btn-orange" msg= "Adding Transaction" /> ) : 'Add' }
                                    </button>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    
                    <footer className="footer">
                        <div className="container-fluid d-flex justify-content-center">
                            <span className="text-muted d-block text-center text-sm-start d-sm-inline-block">Copyright ©
                            <b>DigitalTenant</b> 2022. All Rights Reserved.</span>
                        </div>
                    </footer>
                    
                </div>    
          
            </>
        )
    }
}
export default withRouter(AddTransaction);
